module.exports = __webpack_public_path__ + "media/alerta.17604e40.wav";